<template>
  <div class="statistic-list">
    <!-- Charts -->
    <v-layout row wrap :class="{ 'justify-center': statistics.length === 1 }">
      <template v-for="(graph, index) in statistics">
        <template v-if="graph.graph_type_id === chartType.pie">
          <v-flex
            lg6
            pa-3
            mb-5
            :class="{
              'd-flex': $vuetify.breakpoint.mdAndUp,
              'flex-column': $vuetify.breakpoint.mdAndUp,
            }"
          >
            <CardPieChart
              :ref="`pie-chart-${graph.id}`"
              style="flex: 1"
              :title="graph[`title_${language}`]"
              class="mb-5"
              :unit="graph.topic.data_query[0].index.unit[`name_${language}`]"
              barcolor="#4F4F4F"
              :chartdata="graph.graph.labels"
              :options="graph.graph.values"
              :maxregion="graph[`caption_${language}`]"
              :max="
                formatNumber(
                  graph.graph.values.length
                    ? Math.max(...graph.graph.values)
                    : 0
                )
              "
              :piecolor="areaColor"
              :referenceText="graph[`reference_text_${language}`]"
              :referenceLink="graph.link_data_url"
              dataname="Value"
            ></CardPieChart>
            <v-layout justify-space-between style="flex: 0">
              <v-flex shrink>
                <SeeMore
                  :disable="graph ? false : true"
                  :click="
                    graph.link_data === 2
                      ? { type: 'url', url: graph.link_data_url }
                      : { type: 'push', path: 'industries/' + graph.id }
                  "
                ></SeeMore>
              </v-flex>
              <v-flex shrink>
                <SaveImg
                  :disabled="false"
                  @click="previewChartExport(graph)"
                ></SaveImg>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>

        <template v-if="graph.graph_type_id === chartType.line">
          <v-flex
            lg6
            pa-3
            mb-5
            :class="{
              'd-flex': $vuetify.breakpoint.mdAndUp,
              'flex-column': $vuetify.breakpoint.mdAndUp,
            }"
          >
            <CardLineChart
              :ref="`line-chart-${graph.id}`"
              style="flex: 1"
              :title="graph[`title_${language}`]"
              class="mb-5"
              barcolor="#4F4F4F"
              :chartdata="graph.graph.labels"
              :options="graph.graph.values"
              :maxregion="graph[`caption_${language}`]"
              :referenceText="graph[`reference_text_${language}`]"
              :referenceLink="graph.link_data_url"
              :unit="graph.topic.data_query[0].index.unit[`name_${language}`]"
              dataname="Value"
            ></CardLineChart>
            <v-layout justify-space-between style="flex: 0">
              <v-flex shrink>
                <SeeMore
                  :disable="graph ? false : true"
                  :click="
                    graph.link_data === 2
                      ? { type: 'url', url: graph.link_data_url }
                      : { type: 'push', path: 'industries/' + graph.id }
                  "
                ></SeeMore>
              </v-flex>
              <v-flex shrink>
                <SaveImg
                  :disabled="false"
                  @click="previewChartExport(graph)"
                ></SaveImg>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>

        <template v-if="graph.graph_type_id === chartType.barH">
          <v-flex
            lg6
            pa-3
            mb-5
            :class="{
              'd-flex': $vuetify.breakpoint.mdAndUp,
              'flex-column': $vuetify.breakpoint.mdAndUp,
            }"
          >
            <CardHBarChart
              :ref="`barh-chart-${graph.id}`"
              :style="$vuetify.breakpoint.mdAndUp ? { flex: '1' } : {}"
              class="mb-5"
              v-if="!isLoading"
              :title="graph[`title_${language}`]"
              :year="graph.latestyear"
              :maxregion="graph[`caption_${language}`]"
              :chartdata="graph.graph.labels"
              :options="graph.graph.values"
              dataname="Value"
              :referenceText="graph[`reference_text_${language}`]"
              :referenceLink="graph.link_data_url"
              :unit="graph.topic.data_query[0].index.unit[`name_${language}`]"
            ></CardHBarChart>
            <v-layout
              justify-space-between
              :style="$vuetify.breakpoint.mdAndUp ? { flex: '0' } : {}"
            >
              <v-flex shrink>
                <SeeMore
                  :disable="graph ? false : true"
                  :click="
                    graph.link_data === 2
                      ? { type: 'url', url: graph.link_data_url }
                      : { type: 'push', path: 'industries/' + graph.id }
                  "
                ></SeeMore>
              </v-flex>
              <v-flex shrink>
                <SaveImg
                  :disabled="false"
                  @click="previewChartExport(graph)"
                ></SaveImg>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>

        <template v-if="graph.graph_type_id === chartType.barV">
          <v-flex
            lg6
            pa-3
            mb-5
            :class="{
              'd-flex': $vuetify.breakpoint.mdAndUp,
              'flex-column': $vuetify.breakpoint.mdAndUp,
            }"
          >
            <CardBarChart
              :ref="`barv-chart-${graph.id}`"
              :style="$vuetify.breakpoint.mdAndUp ? { flex: '1' } : {}"
              class="mb-5"
              :title="graph[`title_${language}`]"
              :year="graph.latestyear"
              :maxregion="graph[`caption_${language}`]"
              :chartdata="graph.graph.labels"
              :options="graph.graph.values"
              dataname="Value"
              :referenceText="graph[`reference_text_${language}`]"
              :referenceLink="graph.link_data_url"
              :unit="graph.topic.data_query[0].index.unit[`name_${language}`]"
            ></CardBarChart>
            <v-layout
              justify-space-between
              :style="$vuetify.breakpoint.mdAndUp ? { flex: '0' } : {}"
            >
              <v-flex shrink>
                <SeeMore
                  :disable="graph ? false : true"
                  :click="
                    graph.link_data === 2
                      ? { type: 'url', url: graph.link_data_url }
                      : { type: 'push', path: 'industries/' + graph.id }
                  "
                ></SeeMore>
              </v-flex>
              <v-flex shrink>
                <SaveImg
                  :disabled="false"
                  @click="previewChartExport(graph)"
                ></SaveImg>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>

        <template v-if="graph.graph_type_id === chartType.donut">
          <v-flex
            lg6
            pa-3
            mb-5
            :class="{
              'd-flex': $vuetify.breakpoint.mdAndUp,
              'flex-column': $vuetify.breakpoint.mdAndUp,
            }"
          >
            <CardDoughnutChart
              :ref="`doughnut-chart-${graph.id}`"
              style="flex: 1"
              :title="graph[`title_${language}`]"
              class="mb-5"
              :unit="graph.topic.data_query[0].index.unit[`name_${language}`]"
              barcolor="#4F4F4F"
              :maxregion="graph[`caption_${language}`]"
              :chartdata="graph.graph.labels"
              :options="graph.graph.values"
              :dncolor="areaColor"
              :referenceText="graph[`reference_text_${language}`]"
              :referenceLink="graph.link_data_url"
              dataname="Value"
            ></CardDoughnutChart>
            <v-layout justify-space-between style="flex: 0">
              <v-flex shrink>
                <SeeMore
                  :disable="graph ? false : true"
                  :click="
                    graph.link_data === 2
                      ? { type: 'url', url: graph.link_data_url }
                      : { type: 'push', path: 'industries/' + graph.id }
                  "
                ></SeeMore>
              </v-flex>
              <v-flex shrink>
                <SaveImg
                  :disable="false"
                  @click="previewChartExport(graph)"
                ></SaveImg>
              </v-flex>
            </v-layout>
          </v-flex>
        </template>
      </template>
    </v-layout>

    <v-dialog
      class="overflow-dialog"
      v-model="isPreviewChartExportDialogShow"
      max-width="900"
    >
      <PreviewChartExportDialog v-if="!isLoading" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { domain } from "../services/Constants";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CardLineChart from "../components/CardLineChart";
import CardPieChart from "../components/CardPieChart";
import CardBarChart from "../components/CardBarChart";
import CardHBarChart from "../components/CardHBarChart";
import StatCards from "../components/StatCards";
import CardDoughnutChart from "../components/CardDoughnutChart";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SeeMore from "../components/SeeMore";
import SaveImg from "../components/SaveImg";
import ReportGroup from "../components/ReportGroup";
import PreviewChartExportDialog from "../components/PreviewChartExportDialog";
import { chartType } from "../utils/Constants";
import { yearFormat } from "../utils/Utils";

export default {
  name: "statistic-list",
  components: {
    StatCards,
    CardBarChart,
    CardHBarChart,
    CardPieChart,
    Header,
    Footer,
    CardLineChart,
    CardDoughnutChart,
    Loading,
    SeeMore,
    SaveImg,
    ReportGroup,
    PreviewChartExportDialog,
  },
  props: ["overview"],
  data: () => ({
    http: domain,
    articles: [],
    articlesDataStats: [],
    chartQty: [],
    selectedCategory: null,
    categoryList: [],
    industriesHBar: {},
    gdpChart: {},
    laborChart: {},
    dataChart: {},
    lineLoaded: false,
    barLoaded: false,
    pieLoaded: false,
    isLoading: false,
    searchAll: "ทั้งหมด",
    categoryDesc: "",
    areaColor: [
      "#D1DDEF",
      "#A3B9DC",
      "#7A9ACD",
      "#4D78BD",
      "#1147B4",
      "#FBDED3",
      "#FFC3AD",
      "#FF8E62",
      "#FE6F38",
      "#FFCF0B",
      "#EBEBEB",
      "#D4D4D4",
      "#8A8A8A",
      "#4F4F4F",
      "#000000",
    ],

    chartType: chartType,
    yearFormat: yearFormat,
    output: null,

    isPreviewChartExportDialogShow: false,
  }),
  computed: {
    ...mapState({
      statistic: (state) => state.statistic,
      statistics: (state) => state.statistic.statistics,
      selectYear: function (state) {
        return state.statistic.availableYears.map((year) => {
          return {
            text: this.yearFormat(year, this.$i18n.locale),
            value: year,
          };
        });
      },
      selectedYear: (state) => state.statistic.selectedYear,
      language: (state) => state.locale.language,
    }),
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    async previewChartExport(graph) {
      this.isLoading = true;

      await this.$store.dispatch("chart/setChartToImage", {
        id: graph.id,
        title: graph[`title_${this.language}`],
        // title: 'มูลค่าอุตสาหกรรมสร้างสรรค์ ณ ราคาประจำปี กลุ่มอุตสาหกรรม งานฝีมือและหัตกรรม (Crafts)',
        caption: graph[`caption_${this.language}`],
        // caption: 'มูลค่าอุตสาหกรรมสร้างสรรค์ ณ ราคาประจำปี กลุ่มอุตสาหกรรม งานฝีมือและหัตกรรม (Crafts) ของประเทศไทยในปี พ.ศ. 2562 มีมูลค่า สูง ถึง 1.81 ล้านบาทหรือคิด เป็นร้อยละ 13.18 ของ ผลิตภัณฑ์ มวลรวมใน ประเทศ (GDP) มูลค่ารวม 12.14 ล้านบาท',
        referenceText: graph[`reference_text_${this.language}`],
        chart: {
          labels: graph.graph.labels,
          label: graph[`title_${this.language}`],
          // label: 'มูลค่าอุตสาหกรรมสร้างสรรค์ ณ ราคาประจำปี กลุ่มอุตสาหกรรม งานฝีมือและหัตกรรม (Crafts)',
          type: graph.graph_type_id,
        },
        chartOptions: {
          linecolor: "#1D4E9D", // Line chart exclusive
          pointcolor: "#FF5100", // Line chart exclusive
          barcolor: "#4F4F4F", // Line chart exclusive
          piecolor: this.areaColor, // Line chart exclusive
          lineTension: 0,
          showAllTooltips: true,
        },
        chartData: graph.graph.values,
      });

      this.isLoading = false;
      this.isPreviewChartExportDialogShow = true;
    },
  },
};
</script>
